import React from "react";

// PERSISTENT_LTP_V1 (4 Nov 2026, SHADOW SELL opt-in): the committed profit exit's policy switch and live status.
export const POLICY = "PERSISTENT_LTP_V1";

const rs = (v) => (v == null ? "—" : `₹${Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);

export const STATE_TEXT = {
  COMMITTED: "Committed exit — orders being prepared",
  WORKING: "Committed exit — LIMIT orders working",
  PARTIAL: "Committed exit — partly filled, remainder working / open",
  NEXT_SESSION_WAIT: "Committed exit — market closed, waiting for the next session",
  BUDGET_BLOCKED: "Committed exit — waiting: the remaining limits would put net below the target",
  NO_PRICE: "Committed exit — waiting: a held contract has no recorded LTP",
  EXPIRED_CONTRACT: "Committed exit — contract expired, nothing sent (check the position)",
  AMBIGUOUS_WAIT: "Committed exit — an order's broker status is being confirmed",
  REFUSED_WAIT: "Committed exit — an order was refused, retrying shortly",
  SUPERSEDED: "Committed exit — taken over by a higher-priority exit",
  POSITION_CHECK_WAIT: "Committed exit — waiting: Zerodha position check did not cover the close (nothing sent)",
  COMPLETE: "Committed exit — complete, flat",
};
const BAD = new Set(["POSITION_CHECK_WAIT", "BUDGET_BLOCKED", "NO_PRICE", "EXPIRED_CONTRACT", "AMBIGUOUS_WAIT", "REFUSED_WAIT"]);

export default function CommittedExitPanel({ trade, onPolicy, liveAvailable = false }) {
  const t = trade || {};
  const ce = t.committed_exit;
  const on = t.exit_policy === POLICY;
  const finished = ["COMPLETE", "STOPPED"].includes(t.status);
  const envOk = t.trading_environment === "SHADOW" || (t.trading_environment === "LIVE" && liveAvailable);
  const canSwitch = envOk && !t.exit_in_progress && !finished && onPolicy;
  const label = t.trading_environment === "LIVE" ? "Persistent LTP (LIVE pilot)" : "Persistent LTP (SHADOW test)";
  return (
    <div className="text-[11px] space-y-1" data-testid="committed-exit-panel">
      <div className="flex items-center gap-2">
        <span className="text-[#6b6b6b]">Profit exit policy</span>
        {canSwitch ? (
          <label className="flex items-center gap-1">
            <input type="checkbox" checked={on} data-testid="committed-exit-policy"
              onChange={(e) => onPolicy(e.target.checked ? POLICY : "LEGACY")} />
            {on ? label : "Legacy"}
          </label>
        ) : (
          <span className="mono" data-testid="committed-exit-policy-text">{on ? label : "Legacy"}</span>
        )}
      </div>
      {on && !ce && <div className="text-[#6b6b6b]">Fires on NET P&L at the recorded LTP (stale prints allowed); then stays committed with standing LIMIT orders.</div>}
      {ce && (
        <div data-testid="committed-exit-status">
          <div className={BAD.has(ce.state) ? "text-[#B45309]" : "text-[#008a04]"} data-testid="committed-exit-state">{STATE_TEXT[ce.state] || ce.state}</div>
          <div className="mono">target {rs(ce.target)} (frozen) · trigger net@LTP {rs(ce.trigger?.net_pnl_ltp)} · bid/ask {rs(ce.trigger?.net_pnl_bidask)}</div>
          {ce.budget?.net_at_limits != null && (
            <div className="mono" data-testid="committed-exit-budget">net at limits {rs(ce.budget.net_at_limits)} {ce.budget.ok ? "≥" : "<"} target</div>
          )}
          {ce.budget?.missing?.length > 0 && <div className="mono">no recorded LTP: {ce.budget.missing.join(", ")}</div>}
          <div className="mono" data-testid="committed-exit-qty">bought back {ce.filled_qty ?? 0} · still short {ce.open_qty ?? "—"} · working orders {(ce.working || []).length}</div>
          {(ce.working || []).map((w, i) => (
            <div key={i} className="mono text-[#6b6b6b]">pair {w.pair} · {w.symbol} · BUY {w.qty} @ {w.limit} · filled {w.filled}</div>
          ))}
          {ce.superseded_by && <div className="mono">taken over by {ce.superseded_by}</div>}
        </div>
      )}
    </div>
  );
}
